// extracted by mini-css-extract-plugin
export default {"gallery":"Categories_gallery__W6QWk","imageContainer":"Categories_imageContainer__6Rcuf","title":"Categories_title__yqZmH"};